import { useState } from "react";
import styled from "styled-components";
import { logEvent } from "firebase/analytics";

import WhatsappIcon from "../../../assets/whatsapp_logo.svg";
import NoTextSelectionStyles from "../../../common/styles/no-text-selection";
import { firebaseAnalytics } from "../../../firebase";


const ContactNumber = "+918310852352";

const WhatsappAction = ({ showNumber = false }) => {
    const [contactText, setText] = useState(showNumber ? ContactNumber : "CONTACT US");
    const handleWhatsappClick = () => {
        if (navigator.clipboard) {
            navigator.clipboard?.writeText(ContactNumber);
            setText("Copied!");
            setTimeout(() => {
                setText(showNumber ? ContactNumber : "CONTACT US");
            }, 2000);
        }
        window.open(`https://wa.me/${ContactNumber}`, "_blank");
        try {
            logEvent(firebaseAnalytics, 'whatsapp_number_clicked');
        } catch (error) {
            console.log(error);
        }
    }
    return <WhatsappSC onClick={handleWhatsappClick}>
        <img src={WhatsappIcon} alt="Whatsapp" />
        <span>
            {contactText}
        </span>
    </WhatsappSC>
}

const WhatsappSC = styled.div`
    border-radius: 24px;
    padding: 16px 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    background-color: #0eb670ff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    ${NoTextSelectionStyles}
    
    img {
        height: 24px;
        width: 24px;
    }

    span {
        font-size: 22px;
        margin-top: -2px;
        margin-left: 8px;
        color: #fff;
        font-weight: 500;
        letter-spacing: 0.7px;
    }

    @media (max-width: 768px) {
        border-radius: 16px;
        width: 180px;
        padding: unset;
        height: 36px;

        span {
            font-size: 14px;
            margin-top: 1px;
        }
        img {
            height: 15px;
            width: 15px;
        }
    }
`
export default WhatsappAction;